module.exports = __webpack_public_path__ + "img/chongqing.b509a336.jpg";